/** Constants for the New User Creation form. */

export const NEW_USER_ASSIGN_AUTO = 'AUTO';
export const NEW_USER_ASSIGN_MANUAL = 'MANUAL';
export const NEW_USER_CLONE_SCOPE_CURRENT_ORG = 'CURRENT_ORG';
export const NEW_USER_CLONE_SCOPE_ALL_ORGS = 'ALL_ORGS';

export const NEW_USER_USERNAME_MAX = 500;
export const NEW_USER_COMMENT_MAX = 5000;
